import { OmniaConfig } from "../config"
import { createMap } from "../utils/array"
import { MsgObject, MsgTemplateArguments } from "./messages"
import { I18nService, ResourceType } from "./types"

let svc: I18nService
let config: OmniaConfig

export function setupMessageProvider(_svc: I18nService, _config: OmniaConfig) {
    svc = _svc
    config = _config
}

export function translate(id: string | MsgObject) {

    const { msg, found } = svc?.getMessage(id) ?? { msg: undefined, found: false }
    return found ? msg : `(?${id})`

}

export function formatMessage(msg: string, locals?: MsgTemplateArguments) {
    return svc.formatMessage(msg, locals)
}

export function getLocaleId() {
    return svc.getLanguage()
}

export function getResourceProvider(type: ResourceType) {

    const resources = svc?.getResources(type) ?? []
    const map = createMap(resources, r => r.id)

    return (id: number, defaultText: string) => {
        let text = map.get(id)?.text ?? defaultText
        text = svc?.formatMessage(text) ?? text
        return text
    }

}

export function translateResources<T>(items: T[], type: ResourceType, idSelector: (arg: T) => number, nameProperty: string = "Name") {

    if (svc?.usesDefaultLanguage() ?? true) {
        return items
    }

    const resources = svc?.getResources(type) ?? []
    const map = createMap(resources, r => r.id)

    return items.map(item => {
        const id = idSelector(item)
        const text = map.get(id)?.text ?? `(?${item[nameProperty]})`
        item[nameProperty] = text
        return item
    })

}


export function translateResourcesObject(type: ResourceType, items: { [id: number]: string }) {

    const result: { [id: number]: string } = {}

    let provider: (id: number, defaultText: string) => string

    const translate = (id: number, defaultText: string) => {
        provider = provider ?? getResourceProvider(type)
        return provider(id, defaultText)
    }

    for (const [key, text] of Object.entries(items)) {
        const id = Number(key)
        Object.defineProperty(result, id, {
            enumerable: true,
            get: () => translate(id, text)
        })
    }

    return result

}


export function getRegions() {
    return svc.getRegions()
}

export function getRegion(regionId: number) {
    return svc.getRegion(regionId)
}

export function getTimezones(countryCode?: string) {
    return svc.getTimezones(countryCode)
}
